<template>
  <v-dialog v-model="showModalInternal" max-width="550" @input="$event == false ? close() : ''">
    <v-card>
      <v-card-title>{{ newMiscAccount ? trans('misc.accountCreate') : trans('misc.accountEdit') }}</v-card-title>
      <v-divider/>
      <v-card-text>
        <global-validation-errors class="mt-4" :value="validationErrors" />
        <v-row>
          <v-col cols="12">
            <v-text-field
                :error-messages="validationErrors['accountNbr']"
                :label="trans('misc.accountNbr')"
                v-model="misc.accountNbr"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
                :error-messages="validationErrors['description']"
                :label="trans('misc.description')"
                v-model="misc.description"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <cancel-button @click="$emit('close')"></cancel-button>
        <v-btn :loading="loading" color="primary" @click="sendRequest">{{ trans('general.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CancelButton from './CancelButton'
import {LocaleUtils} from '../utils/locale-utils';
import {RouterUtils} from '../utils/router-utils';
import {MiscAccountApi} from '@/api/misc-account-api';
import {MainUtils} from '@/utils/main-utils';
import GlobalValidationErrors from '@/components/GlobalValidationErrors';

export default {
  name: 'MiscAccountEditModal',
  mixins: [
    MainUtils,
    LocaleUtils,
    RouterUtils
  ],
  components: {GlobalValidationErrors, CancelButton},
  props: {
    showModal: {
      type: Boolean
    },
    initialMiscAccount: {
      type: Object,
      required: false,
    }
  },
  data () {
    return {
      showModalInternal: false,
      loading: false,
      misc: {},
      validationErrors: {}
    }
  },
  computed: {
    newMiscAccount() {
      return this.initialMiscAccount == null || this.initialMiscAccount.id == null;
    }
  },
  methods: {
    sendRequest() {
      if(!this.loading) {
        this.loading = true;
        let request = this.newMiscAccount ? MiscAccountApi.createMiscAccount(this.misc) : MiscAccountApi.updateMiscAccount(this.misc.id, this.misc);
        request.then((response) => {
            this.$emit('success', response.data);
            this.close();
          })
          .catch((response) => this.validationErrors = this.getValidationErrors(response))
          .finally(() => {
            this.loading = false;
          })
      }
    },
    close() {
      this.$emit('close');
    }
  },
  watch: {
    showModal: {
      immediate: true,
      handler: function(showModal) {
        this.validationErrors = {};
        this.showModalInternal = showModal;
        if(showModal) {
          this.misc = JSON.parse(JSON.stringify(this.initialMiscAccount));
        }
      }
    }
  }
}
</script>
